export function serviceCall(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  //TODO: do a service call
  // this function will have side effects since it requires getting the current state for the device
  return reading
}
